import React from 'react';
import { usePricingFigures, usd } from '../../../hooks/usePricingFigures';
const head = 'text-[11.5px] font-bold uppercase tracking-[0.12em] text-[#c5cdd3] whitespace-nowrap';

/** Option C: a short list of our fees, ad spend set apart, hires beside it. */
export function PricingFeeList({
  includeLeader
}: {
  includeLeader: boolean;
}) {
  const f = usePricingFigures(includeLeader);
  const fees = [...(f.showImplementation ? [{
    label: 'Implementation',
    sub: f.implementationNote,
    value: usd(f.implementation),
    deadline: f.promoDeadlineText
  }] : []), {
    label: 'Monthly service',
    sub: f.monthlyNote,
    value: `${usd(f.monthly)} / mo`,
    deadline: null
  }, {
    label: 'Placement bonus',
    sub: f.bonusNote,
    value: `${usd(f.bonus)} / rep`,
    deadline: null,
    accent: true
  }];
  return <div className="grid grid-cols-[1.75fr_1fr] gap-8 items-center" data-id="element-832" data-mp="2hclkr4tmrem4">
      <div data-id="element-833" data-mp="2heg6umgn1crs">
        <div className={head} data-id="element-834" data-mp="2heokigkl4m41">Paid to D2D HIRE</div>
        <ul className="mt-1.5" data-id="element-835" data-mp="33jlpgq8lel3d">
          {fees.map(fee => <li key={fee.label} className="flex items-baseline justify-between gap-4 py-[6px] border-b border-[#222d35]" data-id="element-836" data-mp="38hdi5mh2ab8m">
              <div className="min-w-0" data-id="element-837" data-mp="2tmh3orinsrn3">
                <span className={`text-[15px] font-semibold ${fee.accent ? 'text-[#6fd6b0]' : 'text-white'}`} data-id="element-838" data-mp="2yiy1yejkomdw">
                  {fee.label}
                </span>
                <span className="ml-2 text-[12.5px] text-[#8e9aa4]" data-id="element-839" data-mp="2pjb0jsqufgku">{fee.sub}</span>
                {fee.deadline && <span className="ml-2 text-[13px] font-bold text-[#6fd6b0]" data-id="element-840" data-mp="2auy0ajkq3bkj">
                    {fee.deadline}
                  </span>}
              </div>
              <span className={`shrink-0 text-[16px] font-bold ${fee.accent ? 'text-[#6fd6b0]' : 'text-white'}`} data-id="element-841" data-mp="21sos40cxfuab">
                {fee.value}
              </span>
            </li>)}
        </ul>
        <div className="mt-2 flex items-baseline justify-between gap-4 rounded-md bg-[#1a232a] px-3 py-[6px]" data-id="element-842" data-mp="ccuvha2k5vhq">
          <div className="min-w-0" data-id="element-843" data-mp="7jrx8omu5xv7">
            <span className="text-[15px] font-semibold text-[#c5cdd3]" data-id="element-844" data-mp="2m9q93sdpspu">
              Recommended ad spend
            </span>
            <span className="ml-2 text-[12.5px] text-[#8e9aa4]" data-id="element-845" data-mp="3ttch1u4b1wzj">
              {f.adsNote}, not to D2D HIRE
            </span>
          </div>
          <span className="shrink-0 text-[16px] font-bold text-[#c5cdd3]" data-id="element-846" data-mp="va5ssp4mqeuj">
            {usd(f.adSpend)} / mo
          </span>
        </div>
      </div>
      <div className="border-l border-[#33404a] pl-7" data-id="element-847" data-mp="lc84k1mrsi1x">
        <div className={head} data-id="element-848" data-mp="leuci2dkozko">Projected hires / mo</div>
        <div className="brief-display mt-1 text-[56px] font-extrabold leading-none text-[#6fd6b0]" data-id="element-849" data-mp="ha4ikj2h5v2e">
          {f.hiresLow}–{f.hiresHigh}
        </div>
        <div className="mt-1.5 text-[12.5px] leading-snug text-[#aab4bc]" data-id="element-850" data-mp="360nkxocpktng">
          {usd(f.costLow)}–{usd(f.costHigh)} all-in per hire, incl. est. bonuses
        </div>
      </div>
    </div>;
}